import { ethers } from "ethers";
import {
  nils,
  iso,
  nano,
  tofeth,
  toeth,
  tofpval,
  blocktime_iso,
  base64_to_json,
} from "../../utils/utils.jsx";
import _ from "lodash";
import abi from "./abis/DNA_SkinsBurner.json";
import { CV2_Contract } from "./cv2_base.js";
import { contractAddress_list } from "../contracts.jsx";
import get_logs_parser from "./extra_logs_parsers.js";

const k = "skinsburner";
class Contract extends CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    super({ contract_k, contractAddress, aumode, abi, ...ext });
  }

  async getParsedLogs(logs) {
    if (!logs) return [];

    let logrows = [];
    for (let log of logs) {
      let iface = new ethers.Interface(this.abi);
      let par = iface.parseLog(log);

      if (nils(par)) continue;

      let name = par.name;
      let o = {
        name,
        logIndex: log.logIndex,
        hash: log.transactionHash,
        blockNumber: log.blockNumber,
      };
      o.id = `${o.hash}:${o.logIndex}`;

      // event SkinBurned(string rvmode, uint tokenid, uint reward_sgc)
      if (name == "SkinBurned") {
        let a = par.args;
        o.args = {
          rvmode: a[0],
          tokenid: Number(a[1]),
          reward_sgcw: a[2].toString(),
        };
        o.args.reward_sgc = parseFloat(tofeth(o.args.reward_sgcw));
        o.args.skinid = o.args.tokenid;
      }

      logrows.push(o);
    }

    let el721 = get_logs_parser.erc721(logs);
    logrows = [...logrows, ...el721];
    logrows = _.sortBy(logrows, (e) => e.logIndex);
    // console.log("logrows", logrows.length);
    // console.log(logrows);

    return logrows;
  }
}

const get_contract_address = () => {
  return contractAddress_list.skinsburner;
};

const get_contract = async (ext = {}) => {
  const contractAddress = get_contract_address();
  const runner = new Contract({
    contract_k: k,
    contractAddress,
    aumode: ext.aumode || "thirdweb",
    abi,
    ...ext,
  });
  return runner;
};

const DNA_SkinsBurner = {
  k,
  get_contract,
  get_contract_address,
};

export default DNA_SkinsBurner;
